import {
  IonButton, IonButtons, IonImg, IonLabel,
} from '@ionic/react';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import InsightService from '@/services/insights';
import hubInstance from '@/services/websocket';
import { RootState } from '@/store';

import ShippingMessageCheck from '../../../../../assets/icons/shipping-message-check.svg';
import ShippingFinishedImg from '../../../../../assets/imgs/shipping-client.svg';
import styles from './OperationShippingFinished.module.scss';

interface OperationShippingFinishedProps {
  handleClose: () => void;
}

export default function OperationShippingFinished({ handleClose }: OperationShippingFinishedProps) {
  const creditProposal = useSelector((state: RootState) => state.creditProposal.data);
  const [infoList, setInfoList] = useState<string[] | any>([]);
  const [completed, setCompleted] = useState<boolean>(false);

  const dataList: string[] = [];

  const startWebSocket = (isRetry?: boolean) => {
    if (creditProposal?.credit_proposal_id) {
      const connect$ = hubInstance.connect();
      connect$.subscribe(
        (res) => {
          hubInstance.sendToken(creditProposal?.credit_proposal_id);
        },
        (err) => {
          console.log('HTTP Error', err);
          InsightService.logTrace('superExpressPage', [
            { error: JSON.stringify(err) },
          ]);
          hubInstance.disconnect();
          if (!isRetry) {
            setTimeout(() => {
              startWebSocket(true);
            }, 2000);
          }
        },
      );
    }
  };

  const retrieveMessages = () => {
    const messagesLoaded = sessionStorage.getItem('PLS-Websocket');
    if (messagesLoaded) {
      const list = JSON.parse(messagesLoaded);
      list.forEach((message: any) => {
        dataList.push(message);
      });
      setInfoList(dataList);
    }
  };

  const addTexts = (data: string) => {
    let messageReceived = false;
    dataList?.forEach((text: string) => {
      if (data === text) {
        messageReceived = true;
      }
    });
    !messageReceived && dataList.push(data);
    setInfoList([...dataList]);
  };

  const proccessEnd = () => {
    setCompleted(true);
    hubInstance.disconnect();
  };

  useEffect(() => {
    startWebSocket();
    retrieveMessages();
    hubInstance.paymentStartListener().subscribe(() => {
      addTexts('El cliente ha accedido al pago');
    });

    hubInstance.paymentEndListener().subscribe(() => {
      addTexts('Pago completado con éxito');
    });
    hubInstance.bankreaderStartListener().subscribe(() => {
      addTexts('Se ha iniciado el proceso de Banca Online');
    });
    hubInstance.bankreaderEndListener().subscribe(() => {
      addTexts('Proceso de Banca Online terminado con éxito');
    });
    hubInstance.ibanSelectionListener().subscribe(() => {
      addTexts('Se ha seleccionado una cuenta bancaria');
    });
    hubInstance.decisionResultListener().subscribe(() => {
      addTexts('El crédito ha sido aprobado');
    });
    hubInstance.signatureStartListener().subscribe(() => {
      addTexts('El cliente ha accedido a la firma');
    });
    hubInstance.signatureEndListener().subscribe(() => {
      addTexts('La firma se ha completado con éxito');
    });
    hubInstance.activationListener().subscribe(() => {
      addTexts('Activación completada');
      proccessEnd();
    });
    hubInstance.ocrStartListener().subscribe(() => {
      addTexts('El cliente está adjuntando la documentación');
    });
    hubInstance.ocrEndListener().subscribe(() => {
      addTexts('Documentación adjuntada con éxito');
    });
    hubInstance.decisionRedListener().subscribe(() => {
      addTexts('El crédito ha sido denegado');
      proccessEnd();
    });
    hubInstance.denegationWtdListener().subscribe(() => {
      addTexts('El crédito ha sido denegado');
      proccessEnd();
    });
    hubInstance.denegationTudListener().subscribe(() => {
      addTexts('El cliente ha abandonado el proceso');
      proccessEnd();
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.operationShippingFinishedWrapper}>
      <IonLabel className={styles.modalTitle}>Evolución del proceso por parte del cliente:</IonLabel>
      <div className={styles.operationShippingMsgList}>
        {infoList?.map((info: string) => (
          <div className={styles.operationShippingClientMsg}>
            <img className={styles.operationShippingMsgCheck} src={ShippingMessageCheck} />
            <div className={styles.operationShippingMsgText}>{info}</div>
          </div>
        ))}
        {!completed && (
        <div className={styles.operationShippingClientMsg}>
          <img className={styles.operationShippingMsgCheck} src={ShippingMessageCheck} />
          <div className={styles.operationShippingClientLoading}>
            <div className={styles.operationShippingClientLoadingDots} />
          </div>
        </div>
        )}
      </div>
      <IonImg src={ShippingFinishedImg} className={styles.shippingClientImg} />
      <IonButtons className={styles.operationShippingClientBtn}>
        <IonButton
          className={classNames('nextButton', styles.operationShippingClientBtn)}
          onClick={() => {
            hubInstance.disconnect();
            handleClose();
          }}
        >
          Terminar
        </IonButton>
      </IonButtons>
    </div>
  );
}
